/* eslint-disable eag/no-css-property */
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import styled from 'styled-components';

import i18n from '@dms/i18n';

const StyledContentEditable = styled(ContentEditable)<{$isDisabled?: boolean}>`
  min-height: ${({theme}) => theme.getSize(8)};
  max-height: ${({theme}) => theme.getSize(25)};
  padding: 6px 8px;
  border: 1px solid ${({theme}) => theme.colors.palettes.neutral[60][100]};
  border-radius: ${({theme}) => theme.radii.small};
  color: ${({theme}) => theme.colors.palettes.neutral[800][100]};
  font-size: ${({theme}) => theme.fontSizes.text.small};
  line-height: ${({theme}) => theme.lineHeights.text.small};
  width: 100%;
  resize: vertical;
  overflow-y: auto;
  background: ${({theme}) => theme.colors.palettes.white[10][100]};

  &:focus {
    outline: none;
    border: 1px solid ${({theme}) => theme.colors.palettes.blue[60][100]};
    box-shadow: 0 0 0 4px ${({theme}) => theme.colors.palettes.blue[30][100]};
  }

  a {
    color: ${({theme}) => theme.colors.palettes.blue[60][100]};
  }

  ${({$isDisabled, theme}) =>
    $isDisabled &&
    `
    background-color: ${theme.colors.palettes.neutral[20][100]};
    color: ${theme.colors.palettes.neutral[40][100]};
    border-color: ${theme.colors.palettes.neutral[40][100]};
    cursor: not-allowed;
    pointer-events: none;
    
    &:focus {
      border: 1px solid ${theme.colors.palettes.neutral[40][100]};
      box-shadow: none;
    }
  `}
`;

const StyledPlaceholder = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  pointer-events: none;
  color: ${({theme}) => theme.colors.text.tertiary};
  font-size: ${({theme}) => theme.fontSizes.text.small};
  font-weight: ${({theme}) => theme.fontWeights.regular};
  line-height: ${({theme}) => theme.lineHeights.text.small};
`;

export function Input(props: {isDisabled?: boolean}) {
  return (
    <StyledContentEditable
      aria-placeholder={i18n.t('entity.activityPanel.chat.messagePlaceholder')}
      $isDisabled={props.isDisabled}
      placeholder={
        <StyledPlaceholder>
          {i18n.t('entity.activityPanel.chat.messagePlaceholder')}
        </StyledPlaceholder>
      }
    />
  );
}
